import React, { useState } from "react";
import Alert from "../../../controls/Alert";
import moment from "moment";

import { validateRecord as tripLegsValidator } from "../../Trips/validators/TripLegsValidator";


const AttachCostingValidator = (props) => {
  const record = props.record;
  const extraData = props.extraData;

  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  });

  let field = null;
  let error = false;
  let errorMessage = "";
  let id = null;

  if (!error && !record.costingUuid ) {
    error = true;
    errorMessage = "'Costing Number' is required";
    id = "costingUuid";
  }

  if (!error && (!extraData?.scratchPads || isNaN(record?.scratchPad) || !Array.isArray(extraData?.scratchPads) || extraData?.scratchPads?.length < record.scratchPad || !extraData?.scratchPads[record?.scratchPad])) {
    error = true;
    errorMessage = "A valid 'Scratch Pad' is required";
    id = "scratchPad";
  }

  if (!error && (!record.tripDate || !moment(record.tripDate).isValid())) {
    error = true;
    errorMessage = "'Trip Date' is required";
    id = "tripDate";
  }

  if (!error && (moment(record.tripDate).isBefore(moment()))) {
    error = true;
    errorMessage = "'Trip Date' cannot be in the past";
    id = "tripDate";
  }

  if (!error && (!record.initialTime)) {
    error = true;
    errorMessage = "'Initial Time' is required";
    id = "initialTime";
  }

  if (!error && (record.initialTime.indexOf(":") < 0 || record.initialTime.length < 5 || record.initialTime.length > 5 || !moment(record.initialTime, "HH:mm").isValid())) {
    error = true;
    errorMessage = "'Initial Time' is invalid";
    id = "initialTime";
  }

  if (!error && (!Array.isArray(record.legs) || record.legs.length < 1)) {
    error = true;
    errorMessage = "At least one 'Leg' is required";
    id = "legs";
  }

  if (!error) {
    for (let i = 0; i < record.legs.length; i++) {
      const legState = tripLegsValidator(record.legs[i]);
      if (legState.error) {
        error = true;
        errorMessage = `Leg ${i + 1}: ` + legState.errorMessage;
        id = "legs";
        break;
      }
    }
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage} id={id}/>
  );

}

export default AttachCostingValidator;
